jQuery(function () {
  if (document.body.classList.contains("block-editor-page")) return;

  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  domReady(() => {
    whenGsapReady(() => {
      whenScrollReady(() => {
        initNlpFeatures();
      });
    });
  });

  function initNlpFeatures() {
    const blocks = document.querySelectorAll(".js-nlp-features");
    if (!blocks.length) return;

    const prefersReduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    blocks.forEach((root) => {
      if (root.dataset.init === "1") return;
      root.dataset.init = "1";

      const top = Array.from(root.querySelectorAll(".js-nlp-features-item"));
      const cards = Array.from(root.querySelectorAll(".js-nlp-features-card"));

      if (top.length) {
        gsap.set(top, { autoAlpha: 0, y: 18 });

        const vars = {
          autoAlpha: 1,
          y: 0,
          duration: 0.9,
          ease: "power2.out",
          stagger: 0.08,
          clearProps: "transform",
        };

        if (ScrollTrigger) {
          vars.scrollTrigger = {
            trigger: root,
            start: "top 85%",
            once: true,
            invalidateOnRefresh: true,
          };
        }

        gsap.to(top, vars);
      }

      if (cards.length) {
        gsap.set(cards, { autoAlpha: 0, y: 18 });

        const vars = {
          autoAlpha: 1,
          y: 0,
          duration: 0.85,
          ease: "power2.out",
          stagger: 0.07,
          clearProps: "transform",
        };

        if (ScrollTrigger) {
          vars.scrollTrigger = {
            trigger: root,
            start: "top 78%",
            once: true,
            invalidateOnRefresh: true,
          };
        }

        gsap.to(cards, vars);
      }
    });
  }
});
